import React, { Component } from "react";
import classes from "./Channels.module.css";
import constants from "../../../../globalization";
import checkFilledImg from '../../../../assets/images/Fireboard/checkfilled.png';
import checkImg from '../../../../assets/images/Fireboard/checkbox.png';
import PopupHeader from "../PopupHeader";

const config = [
  {
    id: 0,
    name: "Curbside",
    checked: false,
    type: "curbside",
  },
  {
    id: 1,
    name: "Online",
    checked: false,
    type: "online",
  },
  {
    id: 2,
    name: "Walk Up",
    checked: false,
    type: "walkup",
  },
];

class Channels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prepTime: props.prepTime,
      production: props.production,
      channelArr: config.map((c) => {
        const { countStatus } = props || {};
        return {
          ...c,
          checked: countStatus[c.type],
        };
      }),
    };
  }

  onChangePrepTime = (e) => {
    e.stopPropagation();
    this.setState({ prepTime: e.target.value });
  };

  onChangeProdRate = (e) => {
    e.stopPropagation();
    this.setState({ production: e.target.value });
  };

  get renderChannels() {
    const { channelArr = [] } = this.state || {};
    const { onToggleCount } = this.props || {};
    return (
      Array.isArray(channelArr) &&
      channelArr.length &&
      channelArr.map((channel) => {
        return (
          <div  className={classes.channel} key={channel.id}  onClick={() => onToggleCount(channel.type)}  >
            <div onClick={() => onToggleCount(channel.type)} >
              { channel.checked?
               <img src={checkFilledImg} className={classes.checkbox}   alt="" />:
               <img src={checkImg} className={classes.checkbox} alt=""/>
              }
            </div>
            <span className={classes.channelNameText}>{channel.name}</span>
          </div>
        );
      })
    );
  }

  render() {
    const { prepTime, production } = this.state || {};
    const { onUpdate ,onClose} = this.props || {};
    return (
      <div className={classes.container}>
        <PopupHeader title={constants.channelSettings} onClose={onClose} containerStyle={classes.heading} />

        <div className={classes.prepProdContainer}>
          <div className={classes.settingsContainer}>
            <div className={classes.headerText}>
              {constants.updateChannelSettings}
            </div>
            <div className={classes.channelContainer}>{this.renderChannels}</div>
          </div>

            <div className={classes.headerText}>
              {constants.channelsUpdateTimeRate}
            </div>
            <div className={classes.prepTimeContainer}>
              <span className={classes.subText}>
                {constants.channelsPrepTime}
              </span>
              <input
                className={classes.inputContainer}
                type="number"
                value={prepTime}
                onChange={(e) => this.onChangePrepTime(e)}
              />
              <button onClick={() => onUpdate("prepTime", prepTime)} className={classes.button}>
                <span className={classes.updateButton}>
                  {constants.channelsUpdate}
                </span>
              </button>
            </div>

            <div className={classes.prepTimeContainer}>
              <span className={classes.subText}>
                {constants.channelsProductionRate}
              </span>
              <input
                className={classes.inputContainer}
                type="number"
                value={production}
                onChange={(e) => this.onChangeProdRate(e)}
              />
              <button onClick={() => onUpdate("productionRate", production)} className={classes.button}>
                <span className={classes.updateButton}>
                  {constants.channelsUpdate}
                </span>
              </button>
            </div>
        </div>
      </div>
    );
  }
}

export default Channels;
